import React from 'react';
import get from 'lodash/get';

import { ModuleHierarchy } from 'labxchange-client';
import { renderSubModulesList } from 'utils';

import {
  CURRICULUM_MODULE_HEADING_MAP,
  ExtendedModuleHierarchy,
} from '../../utils';

interface CurriculumModuleCardProps {
  curriculumModule: ExtendedModuleHierarchy;
  curriculumSlug: string;
  subject: string;
  grade: string;
  onModuleClick?: (module: ModuleHierarchy) => void;
  hideModuleNumber?: boolean;
}

export const CurriculumModuleCard = ({
  curriculumModule,
  curriculumSlug,
  subject,
  grade,
  onModuleClick,
  hideModuleNumber,
}: CurriculumModuleCardProps) => {
  return (
    <div className='curriculum-module-card'>
      <div className='left-section'>
        {!hideModuleNumber && (
          <span className='module-number'>
            {`${get(
              CURRICULUM_MODULE_HEADING_MAP,
              curriculumSlug,
              CURRICULUM_MODULE_HEADING_MAP.default
            )} ${curriculumModule.index}`}
          </span>
        )}
        <span className='module-name font-s-lt'>{curriculumModule.name}</span>
      </div>
      <div className='right-section'>
        {renderSubModulesList(
          curriculumModule.subModules || curriculumModule.sub_modules,
          curriculumSlug,
          subject,
          grade,
          1,
          onModuleClick
        )}
      </div>
    </div>
  );
};

export default CurriculumModuleCard;
